/* eslint-disable no-loop-func */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "../../components/ui/use-toast";
import * as XLSX from "xlsx";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "../../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import FileUpload from "../../components/FileUpload";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import {
  dateFormatReader,
  ExcelDateFormat,
  formatBSBNumber,
  getModuleNamingBySlug,
  padWithLeadingZeros,
} from "../../lib/Misc";
import moment from "moment";
import { useOrganization } from "../../lib/context/OrganisationContext";

const UploadReceipt = ({ fetchData, trustId, ButtonName, setLoading }) => {
  const [showImport, setShowImport] = useState(false);
  const [files, setFiles] = useState([]);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelContactData, setExcelContactData] = useState();
  const [isImportLoading, setIsImportLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const { organizationData } = useOrganization();

  const methodList = [
    { label: "Select Payment Method", value: "Select Payment Method" },
    { label: "EFT", value: "EFT", method_type: 1 },
    { label: "BPay", value: "BPay", method_type: 2 },
    { label: "Cash", value: "Cash", method_type: 3 },
    { label: "PayId", value: "PayId", method_type: 4 },
  ];

  const handleDownload = async (sample) => {
    try {
      setLoading(true);
      let api = sample
        ? `${API.DOWNLOAD_RECEIPT_TEMPLATE}?sample=${sample}&trust_id=${
            trustId ? trustId : ""
          }`
        : `${API.EXPORT_RECEIPT}?trust_id=${trustId ? trustId : ""}`;
      const { data } = await get(api);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("target", "_blank");
        a.setAttribute("download", file[file.length - 1] || "receipts.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleImportModal = async () => {
    setShowImport(!showImport);
  };

  const handleExcelClose = () => {
    setExcelSelectedRow([]);
    setShowExcelModal(false);
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleImportClose = () => {
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleClose = () => {
    setFiles([]);
  };

  const ExcelColumns = [
    {
      headerClasses: THClasses,
      dataField: "code",
      // text: `${getModuleNamingBySlug(
      //   organizationData?.organizationData,
      //   "contacts",
      //   "Customer"
      // )} Code`,
      text: (
        <div>
                  <span className="required">*</span>
                  {`${getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "contacts",
                    "Customer"
                  )} Code`}
                </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Code is Required",
          };
        } else {
          return true;
        }
      },
    },
    {
      headerClasses: THClasses,
      dataField: "first_name",
      text: `First Name`,
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "last_name",
      text: (
        <div>
          <span className="required">*</span>Last Name
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Last Name is Required",
          };
        }
        return true;
      },
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "phone",
      text: `Phone`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (newValue.split(" ").join("").length !== 10) {
            return {
              valid: false,
              message: "Please enter valid phone number",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (cell.split(" ").join("").length !== 10) {
            return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "mobile",
      text: `Mobile`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (newValue.split(" ").join("").length !== 10) {
            return {
              valid: false,
              message: "Please enter valid mobile number",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (cell.split(" ").join("").length !== 10) {
            return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "email",
      // text: (
      //   <div>
      //     <span className="required">*</span>Email
      //   </div>
      // ),
      text: "Email",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        // if (newValue === "" || newValue === undefined || newValue === null) {
        //   return {
        //     valid: false,
        //     message: "Email is Required",
        //   };
        // } else {
          if (newValue) {
            if (
              !newValue
                .toLowerCase()
                .match(
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
            ) {
              return {
                valid: false,
                message: "Please enter a valid email address",
              };
            }
          }

          return true;
        // }
      },
      classes: (cell) => {
        if (cell) {
          if (
            !String(cell)
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              )
          ) {
            return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "business_name",
      text: `Business Name`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(newValue)) {
            return {
              valid: false,
              message:
                "Business name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.", // Display the error message when validation fails
            };
          }
        }
        return true; // If valid, return true
      },

      // Optionally add CSS classes for invalid input (e.g., to highlight the field in red)
      classes: (cell) => {
        if (cell && !/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(cell)) {
          return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`; // Apply error styling
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "abn",
      text: `ABN`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          let weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          if (
            !String(newValue)
              .split(" ")
              .join("")
              .match(/^[\d]{11}$/)
          ) {
            return {
              valid: false,
              message: "Enter 11 Digit ABN Number",
            };
          }
          if (newValue.split(" ").join("").length === 11) {
            let newNumber = newValue.split(" ").join("");
            let sum = 0;
            weights.forEach((item, index) => {
              let digit = newNumber[index] - (index ? 0 : 1);
              sum += item * digit;
            });
            if (sum % 89 !== 0) {
              return {
                valid: false,
                message: "Enter Valid ABN Number",
              };
            }
          }
        }
      },
      classes: (cell) => {
        if (cell) {
          let weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          if (cell.split(" ").join("").length !== 11) {
            return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
          }
          if (cell.split(" ").join("").length === 11) {
            let newNumber = cell.split(" ").join("");
            let sum = 0;
            weights.forEach((item, index) => {
              let digit = newNumber[index] - (index ? 0 : 1);
              sum += item * digit;
            });
            if (sum % 89 !== 0) {
              return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
            }
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "license_number",
      text: `Licence No.`,
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "street",
      text: `Street`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(newValue)) {
            return {
              valid: false,
              message:
                "Street name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.", // Display the error message when validation fails
            };
          }
        }
        return true; // If valid, return true
      },

      // Optionally add CSS classes for invalid input (e.g., to highlight the field in red)
      classes: (cell) => {
        if (cell && !/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(cell)) {
          return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`; // Apply error styling
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "suburb",
      text: `Suburb`,
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "state",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer"
      )} State`,
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "postal_code",
      text: `Postal Code`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!newValue.match(/^[\d]{4}$/)) {
            return {
              valid: false,
              message: "Postal Code can contain 4 digit numbers.",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (!String(cell).match(/^[\d]{4}$/)) {
            return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "bank_name",
      text: `Bank Name`,
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "account_name",
      text: `Account Name`,
      editCellClasses: "edit-cell-excel-class",
      classes: `${TDClasses} bg-yellow-100 dark:bg-amber-500`,
    },
    {
      headerClasses: THClasses,
      dataField: "bsb",
      text: `BSB`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (String(newValue).match(/[\d]*$/)) {
            if (
              String(newValue).match("-")?.index === 3 ||
              !String(newValue).match("-")
            ) {
              if (String(newValue).match("-")) {
                if (newValue.split("-").join("").length > 6) {
                  return {
                    valid: false,
                    message: "Enter 6 Digit BSB Number",
                  };
                }
              } else {
                if (newValue.length > 6) {
                  return {
                    valid: false,
                    message: "Enter 6 Digit BSB Number",
                  };
                }
              }
            } else {
              return {
                valid: false,
                message: "Enter 6 Digit BSB Number",
              };
            }
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (String(cell).match(/[\d]*$/)) {
            if (
              String(cell).match("-")?.index === 3 ||
              !String(cell).match("-")
            ) {
              if (String(cell).match("-")) {
                if (String(cell).split("-").join("").length > 6) {
                  return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
                }
              } else {
                if (String(cell).length > 6) {
                  return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
                }
              }
            } else {
              return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
            }
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "account_number",
      text: `Account Number`,
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (newValue.length > 9) {
            return {
              valid: false,
              message: "Please enter vaild 9 digit Account Number",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (cell.length > 9) {
            return `${TDClasses} text-red-500 bg-yellow-100 dark:bg-amber-500`;
          }
        }
        return `${TDClasses} bg-yellow-100 dark:bg-amber-500`;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "received_date",
      // text: (
      //   <div>
      //     <span className="required">*</span>Received Date
      //   </div>
      // ),
      text: "Received Date",
      editCellClasses: "edit-cell-excel-class",
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell === "string" && cell?.includes("-") && cell) {
          dateObj = cell?.split("-");
          if (dateObj[2]?.length > 2) {
            return `${dateObj[0]}-${dateObj[1]}-${dateObj[2]}`;
          } else {
            return `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
          }
        }
        if (typeof cell !== "object" && cell) {
          var utc_days = Math.floor(cell - 25569);
          var utc_value = utc_days * 86400;
          dateObj = new Date(utc_value * 1000);
        }
        if (cell) {
          return `${("0" + dateObj?.getUTCDate()).slice(-2)}-${(
            "0" +
            (dateObj?.getUTCMonth() + 1)
          ).slice(-2)}-${dateObj?.getUTCFullYear()}`;
        }
      },
      editor: {
        type: Type.DATE,
      },
      // validator: (newValue) => {
      //   if (newValue === "" || newValue === undefined || newValue === null) {
      //     return {
      //       valid: false,
      //       message: "Received Date is Required",
      //     };
      //   }
      //   return true;
      // },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "transaction_date",
      text: (
        <div>
          <span className="required">*</span>Transaction Date
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell === "string" && cell?.includes("-") && cell) {
          dateObj = cell?.split("-");
          if (dateObj[2]?.length > 2) {
            return `${dateObj[0]}-${dateObj[1]}-${dateObj[2]}`;
          } else {
            return `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
          }
        }
        if (typeof cell !== "object" && cell) {
          var utc_days = Math.floor(cell - 25569);
          var utc_value = utc_days * 86400;
          dateObj = new Date(utc_value * 1000);
        }
        if (cell) {
          return `${("0" + dateObj?.getUTCDate()).slice(-2)}-${(
            "0" +
            (dateObj?.getUTCMonth() + 1)
          ).slice(-2)}-${dateObj?.getUTCFullYear()}`;
        }
      },
      editor: {
        type: Type.DATE,
      },
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Transaction Date is Required",
          };
        }
        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "note",
      text: "Note",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "invoice_number",
      // text: (
      //   <div>
      //     <span className="required">*</span>Invoice No.
      //   </div>
      // ),
      text: "Invoice No.",
      editCellClasses: "edit-cell-excel-class",
      // validator: (newValue) => {
      //   if (newValue === "" || newValue === undefined || newValue === null) {
      //     return {
      //       valid: false,
      //       message: "Invoice Number is Required",
      //     };
      //   }
      //   return true;
      // },
      classes: TDClasses,
    },
    {
      dataField: "payment_method",
      // text: (
      //   <div>
      //     <span className="required">*</span>Payment Method
      //   </div>
      // ),
      text: "Payment Method",
      editor: {
        type: Type.SELECT,
        options: methodList,
      },
      editCellClasses: "edit-cell-excel-class",
      classes: (cell) => {
        if (String(cell)?.length === 0) {
          return `${TDClasses} text-red-500 border-red-500 border-y border-r-inherit`;
        } else if (String(cell) === "Select Payment Method") {
          return `${TDClasses} text-red-500`;
        }
        return TDClasses;
      },
      headerClasses: THClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "description",
      text: (
        <div>
          <span className="required">*</span>Description
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Description is Required",
          };
        }
        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "sub_asset_identifier",
      text: (
        <div>
          <span className="required">*</span>
          {`${getModuleNamingBySlug(
            organizationData?.organizationData,
            "sub-assets",
            "Sub Asset"
          )} Identifier`}
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "sub-assets",
              "Sub Asset"
            )} Identifier is Required`,
          };
        }
        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "job_code",
      text: "Job Code",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "task_code",
      text: "Task Code",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "contract_number",
      text: "Contract No.",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "from_date",
      text: <div>From Date</div>,
      editCellClasses: "edit-cell-excel-class",
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell === "string" && cell?.includes("-") && cell) {
          dateObj = cell?.split("-");
          if (dateObj[2]?.length > 2) {
            return `${dateObj[0]}-${dateObj[1]}-${dateObj[2]}`;
          } else {
            return `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
          }
        }
        if (typeof cell !== "object" && cell) {
          var utc_days = Math.floor(cell - 25569);
          var utc_value = utc_days * 86400;
          dateObj = new Date(utc_value * 1000);
        }
        if (cell) {
          return `${("0" + dateObj?.getUTCDate()).slice(-2)}-${(
            "0" +
            (dateObj?.getUTCMonth() + 1)
          ).slice(-2)}-${dateObj?.getUTCFullYear()}`;
        }
      },
      editor: {
        type: Type.DATE,
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "to_date",
      text: <div>To Date</div>,
      editCellClasses: "edit-cell-excel-class",
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell === "string" && cell?.includes("-") && cell) {
          dateObj = cell?.split("-");
          if (dateObj[2]?.length > 2) {
            return `${dateObj[0]}-${dateObj[1]}-${dateObj[2]}`;
          } else {
            return `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
          }
        }
        if (typeof cell !== "object" && cell) {
          var utc_days = Math.floor(cell - 25569);
          var utc_value = utc_days * 86400;
          dateObj = new Date(utc_value * 1000);
        }
        if (cell) {
          return `${("0" + dateObj?.getUTCDate()).slice(-2)}-${(
            "0" +
            (dateObj?.getUTCMonth() + 1)
          ).slice(-2)}-${dateObj?.getUTCFullYear()}`;
        }
      },
      editor: {
        type: Type.DATE,
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "amount_exc",
      text: (
        <div>
          <span className="required">*</span>Amount (Ex)
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Amount (Ex) is Required",
          };
        }

        const numberValue = Number(newValue);

        if (isNaN(numberValue)) {
          return {
            valid: false,
            message: "Amount (Ex) must be a number",
          };
        }

        if (numberValue <= 0) {
          return {
            valid: false,
            message: "Amount (Ex) must be greater than 0",
          };
        }

        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "tax_amount",
      text: (
        <div>
          <span className="required">*</span>Tax Amount
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Tax Amount is Required",
          };
        }

        const numberValue = Number(newValue);

        if (isNaN(numberValue)) {
          return {
            valid: false,
            message: "Tax Amount must be a number",
          };
        }

        if (numberValue < 0) {
          return {
            valid: false,
            message: "Tax Amount must be greater than 0 or equal to 0",
          };
        }

        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "net_amount",
      text: (
        <div>
          <span className="required">*</span>Net Amount (Inc)
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Net Amount (Inc) is Required",
          };
        }

        const numberValue = Number(newValue);

        if (isNaN(numberValue)) {
          return {
            valid: false,
            message: "Net Amount (Inc) must be a number",
          };
        }

        if (numberValue < 0) {
          return {
            valid: false,
            message: "Net Amount (Inc) must be greater than 0 or equal to 0",
          };
        }

        return true;
      },
      classes: TDClasses,
    },
  ];

  const [excelSelectedRow, setExcelSelectedRow] = useState([]);

  let singleExcelSelectedRows = [];
  let allExcelSelectedRows = [];

  const excelSelectRow = {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    nonSelectable: ["not-select"],
    selected: excelSelectedRow,
    nonSelectableClasses: "not-selected-class",
    onSelect: (row, isSelect, rowIndex, e) => {
      singleExcelSelectedRows = [...excelSelectedRow];
      if (isSelect) {
        singleExcelSelectedRows = [...excelSelectedRow, row?.key];
      } else {
        singleExcelSelectedRows.splice(excelSelectedRow.indexOf(row?.key), 1);
      }
      setExcelSelectedRow(singleExcelSelectedRows);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
          } else {
            allExcelSelectedRows.push(rows[i].key);
          }
        }
      } else {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
            excelSelectedRow.splice(excelSelectedRow.indexOf(rows[i].key), 1);
          }
        }
      }
      setExcelSelectedRow([...excelSelectedRow, ...allExcelSelectedRows]);
    },
  };

  const excelRef = useRef();

  function getRealRange(ws) {
    let range = {
      s: { r: Number.MAX_VALUE, c: Number.MAX_VALUE },
      e: { r: 0, c: 0 },
    };

    Object.keys(ws).forEach((addr) => {
      if (addr[0] === "!") return; // skip metadata like !ref
      const cell = ws[addr];
      if (cell && cell.v !== undefined && String(cell.v).trim() !== "") {
        const ref = XLSX.utils.decode_cell(addr);
        if (ref.r < range.s.r) range.s.r = ref.r;
        if (ref.c < range.s.c) range.s.c = ref.c;
        if (ref.r > range.e.r) range.e.r = ref.r;
        if (ref.c > range.e.c) range.e.c = ref.c;
      }
    });

    return range;
  }

  const phoneFormat = (value) => {
    if (String(value)?.match(/\+61/)) {
      // let numberWithout61 = String(value)?.split("+61")[1];
      let numberData = String(value)?.split(" ")?.join("");

      if (numberData.length < 10) {
        numberData = `0${Number(numberData)}`; // Pad with leading zeros to make it 10 digits
      }

      return `${numberData.substring(0, 2)} ${numberData.substring(
        2,
        6
      )} ${numberData.substring(6)}`;
    } else {
      if (value) {
        let numberData = String(value)?.split(" ")?.join("");
        if (numberData.length < 10) {
          numberData = `0${Number(numberData)}`; // Pad with leading zeros to make it 10 digits
        }
        return `${String(numberData).substring(0, 2)} ${String(
          numberData
        ).substring(2, 6)} ${String(numberData).substring(6)}`;
      }
    }
  };

  const ExcelReader = () => {
    let f = files[0];
    const reader = new FileReader();
    let data = null;
    setFileLoading(true);

    reader.onload = async (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const arrayString = new Uint8Array(evt.target.result);

      // ✅ Parse workbook using fast "array" mode
      const wb = XLSX.read(arrayString, {
        type: "array",
        cellText: false,
        cellStyles: false,
        cellFormula: false, // skip formulas for speed
        raw: true,
      });

      // ✅ Get first worksheet
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      const realRange = await getRealRange(ws);

      /* Convert array of arrays */
      const jsonData = await XLSX.utils.sheet_to_json(ws, {
        header: 1,
        defval: "",
        blankrows: false,
        range: realRange,
      });
      setFileLoading(false);

      data = jsonData.filter((row) =>
        Object.values(row).some((val) => String(val).trim() !== "")
      );

      /* Update state */
      let selectItem = [];

      const businessExcelGenerator = (quantity) => {
        const items = [];

        if (
          String(data[0][0]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Code` ||
          String(data[0][1]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} First Name` ||
          String(data[0][2]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Last Name` ||
          String(data[0][3]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Phone` ||
          String(data[0][4]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Mobile` ||
          String(data[0][5]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Email` ||
          String(data[0][6]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Business Name` ||
          String(data[0][7]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} ABN` ||
          String(data[0][8]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} License No.` ||
          String(data[0][9]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Street` ||
          String(data[0][10]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Suburb` ||
          String(data[0][11]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} State` ||
          String(data[0][12]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Postal Code` ||
          String(data[0][13]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Bank Name` ||
          String(data[0][14]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Account Name` ||
          String(data[0][15]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} BSB` ||
          String(data[0][16]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "Customer"
            )} Account Number` ||
          String(data[0][17]).replace("*", "") !== "Received Date" ||
          String(data[0][18]).replace("*", "") !== "Transaction Date" ||
          String(data[0][19]).replace("*", "") !== "Note" ||
          String(data[0][20]).replace("*", "") !== "Invoice No." ||
          String(data[0][21]).replace("*", "") !== "Payment Method" ||
          String(data[0][22]).replace("*", "") !== "Description" ||
          String(data[0][23]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "sub-assets",
              "Sub Asset"
            )} Identifier` ||
          String(data[0][24]).replace("*", "") !== "Job Code" ||
          String(data[0][25]).replace("*", "") !== "Task Code" ||
          String(data[0][26]).replace("*", "") !== "Contract No." ||
          String(data[0][27]).replace("*", "") !== "From Date" ||
          String(data[0][28]).replace("*", "") !== "To Date" ||
          String(data[0][29]).replace("*", "") !== "Amount (Ex)" ||
          String(data[0][30]).replace("*", "") !== "Tax Amount" ||
          String(data[0][31]).replace("*", "") !== "Net Amount (Inc)"
        ) {
          setShowExcelModal(false);
          setFiles();
          setIsImportLoading(false);
          toast({
            variant: "destructive",
            description:
              "Sorry, File is not in the given format, please download the latest format again",
            duration: 3000,
          });
        } else {
          for (let i = 1; i < quantity; i++) {
            if (data[i].length > 0) {
              let received_date =
                typeof data[i][17] === "number"
                  ? dateFormatReader(data[i][17])
                  : data[i][17]?.split("-")[2] > 2
                  ? ExcelDateFormat(data[i][17])
                  : ExcelDateFormat(
                      data[i][17]?.split("-")?.reverse()?.join("-")
                    );
              let transaction_date =
                typeof data[i][18] === "number"
                  ? dateFormatReader(data[i][18])
                  : data[i][18]?.split("-")[2] > 2
                  ? ExcelDateFormat(data[i][18])
                  : ExcelDateFormat(
                      data[i][18]?.split("-")?.reverse()?.join("-")
                    );

              let from_date =
                typeof data[i][27] === "number"
                  ? dateFormatReader(data[i][27])
                  : data[i][27]?.split("-")[2] > 2
                  ? ExcelDateFormat(data[i][27])
                  : ExcelDateFormat(
                      data[i][27]?.split("-")?.reverse()?.join("-")
                    );

              let to_date =
                typeof data[i][28] === "number"
                  ? dateFormatReader(data[i][28])
                  : data[i][28]?.split("-")[2] > 2
                  ? ExcelDateFormat(data[i][28])
                  : ExcelDateFormat(
                      data[i][28]?.split("-")?.reverse()?.join("-")
                    );

              const formatBSB = data[i][15]
                ? formatBSBNumber(
                    padWithLeadingZeros(
                      data[i][15].toString()?.includes("-")
                        ? Number(data[i][15].toString()?.split("-").join(""))
                        : Number(data[i][15]),
                      6
                    )
                  )
                : "";
              selectItem.push(i);
              items.push({
                key: i,

                code: data[i][0] ? data[i][0] : "",
                first_name: data[i][1] ? data[i][1] : "",
                last_name: data[i][2] ? data[i][2] : "",
                phone: data[i][3] ? phoneFormat(data[i][3]) : "",
                mobile: data[i][4] ? phoneFormat(data[i][4]) : "",
                email: data[i][5] ? data[i][5] : "",
                business_name: data[i][6] ? data[i][6] : "",
                abn: data[i][7]
                  ? `${Number(String(data[i][7])?.split(" ")?.join(""))
                      .toLocaleString("en-US")
                      .replaceAll(",", " ")}`
                  : "",
                license_number: data[i][8] ? data[i][8] : "",
                street: data[i][9] ? data[i][9] : "",
                suburb: data[i][10] ? data[i][10] : "",
                state: data[i][11] ? data[i][11] : "",
                postal_code: data[i][12] ? data[i][12] : "",
                bank_name: data[i][13] ? data[i][13] : "",
                account_name: data[i][14] ? data[i][14] : "",
                bsb: formatBSB,
                account_number: data[i][16] ? data[i][16] : "",

                received_date:
                  typeof data[i][17] === "string"
                    ? received_date?.split("-")?.reverse()?.join("-")
                    : received_date
                    ? received_date
                    : "",
                transaction_date:
                  typeof data[i][18] === "string"
                    ? transaction_date?.split("-")?.reverse()?.join("-")
                    : transaction_date
                    ? transaction_date
                    : "",
                note: data[i][19] ? data[i][19] : "",
                invoice_number: data[i][20] ? data[i][20] : "",
                payment_method: data[i][21]
                  ? methodList.find((item) => item.value === data[i][21])
                    ? data[i][21]
                    : "EFT"
                  : "EFT",
                description: data[i][22] ? data[i][22] : "",
                sub_asset_identifier: data[i][23] ? data[i][23] : "",
                job_code: data[i][24] ? data[i][24] : "",
                task_code: data[i][25] ? data[i][25] : "",
                contract_number: data[i][26] ? data[i][26] : "",

                from_date:
                  typeof data[i][27] === "string"
                    ? from_date?.split("-")?.reverse()?.join("-")
                    : from_date
                    ? from_date
                    : "",
                to_date:
                  typeof data[i][28] === "string"
                    ? to_date?.split("-")?.reverse()?.join("-")
                    : to_date
                    ? to_date
                    : "",
                amount_exc: data[i][29]
                  ? Number(Number(data[i][29]).toFixed(2))
                  : "",
                tax_amount: data[i][30]
                  ? Number(Number(data[i][30]).toFixed(2))
                  : "",
                net_amount: data[i][31]
                  ? Number(Number(data[i][31]).toFixed(2))
                  : "",
              });
            }
          }
        }
        return items;
      };

      setExcelSelectedRow(selectItem);
      setExcelContactData(businessExcelGenerator(data?.length));
    };
    reader.readAsArrayBuffer(f);
  };

  useEffect(() => {
    showExcelModal && ExcelReader();
    // eslint-disable-next-line
  }, [showExcelModal]);

  const handleExcelModal = () => {
    setShowExcelModal(true);
  };

  const handleUpload = async () => {
    if (excelSelectedRow.length > 1000) {
      toast({
        description: "Maximum limit to import contacts is 1000",
        duration: 3000,
      });
    } else {
      // if (files) {
      setShowExcelModal(true);
      const formData = new FormData();

      formData.append("trust_id", trustId);

      for (let i = 0; i < excelSelectedRow.length; i++) {
        let row = excelContactData.find(
          (item) => item.key === excelSelectedRow[i]
        );
        let rowPhone = row.phone ? row.phone.split(" ") : "";
        let rowMobile = row.mobile ? row.mobile.split(" ") : "";
        row.phone = rowPhone ? rowPhone.join("") : "";
        row.mobile = rowMobile ? rowMobile.join("") : "";
        row.abn = row.abn ? row.abn.split(" ").join("") : "";
        row.account_number =
          row.account_number === "000000000" || !row.account_number
            ? ""
            : padWithLeadingZeros(row.account_number, 9);
        row.bsb = row.bsb === "000-000" || !row.bsb ? "" : row.bsb;
        // row.bsb = row.bsb.split("-").join("");

        if (typeof row.transaction_date !== "object") {
          if (row.transaction_date) {
            let invoiceTransactionDateTemp = String(row.transaction_date)
              ?.split("T")[0]
              ?.split("-");
            if (invoiceTransactionDateTemp[2]?.length === 4) {
              row.transaction_date = `${invoiceTransactionDateTemp[0]}-${invoiceTransactionDateTemp[1]}-${invoiceTransactionDateTemp[2]}`;
            } else {
              row.transaction_date = `${invoiceTransactionDateTemp[2]}-${invoiceTransactionDateTemp[1]}-${invoiceTransactionDateTemp[0]}`;
            }
          }
        } else {
          if (row.transaction_date) {
            row.transaction_date = moment(
              row?.transaction_date,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
          }
        }

        if (typeof row.from_date !== "object") {
          if (row.from_date) {
            let invoiceFromDateTemp = String(row.from_date)
              ?.split("T")[0]
              ?.split("-");
            if (invoiceFromDateTemp[2]?.length === 4) {
              row.from_date = `${invoiceFromDateTemp[0]}-${invoiceFromDateTemp[1]}-${invoiceFromDateTemp[2]}`;
            } else {
              row.from_date = `${invoiceFromDateTemp[2]}-${invoiceFromDateTemp[1]}-${invoiceFromDateTemp[0]}`;
            }
          }
        } else {
          if (row.from_date) {
            row.from_date = moment(row?.from_date, "YYYY-MM-DD").format(
              "DD-MM-YYYY"
            );
          }
        }

        if (typeof row.to_date !== "object") {
          if (row.to_date) {
            let invoiceToDateTemp = String(row.to_date)
              ?.split("T")[0]
              ?.split("-");
            if (invoiceToDateTemp[2]?.length === 4) {
              row.to_date = `${invoiceToDateTemp[0]}-${invoiceToDateTemp[1]}-${invoiceToDateTemp[2]}`;
            } else {
              row.to_date = `${invoiceToDateTemp[2]}-${invoiceToDateTemp[1]}-${invoiceToDateTemp[0]}`;
            }
          }
        } else {
          if (row.to_date) {
            row.to_date = moment(row?.to_date, "YYYY-MM-DD").format(
              "DD-MM-YYYY"
            );
          }
        }

        if (typeof row.received_date !== "object") {
          if (row.received_date) {
            let receivedDateTemp = String(row.received_date)
              ?.split("T")[0]
              ?.split("-");
            // row.received_date = `${receivedDateTemp[2]}-${receivedDateTemp[1]}-${receivedDateTemp[0]}`;
            if (receivedDateTemp[2]?.length === 4) {
              row.received_date = `${receivedDateTemp[0]}-${receivedDateTemp[1]}-${receivedDateTemp[2]}`;
            } else {
              row.received_date = `${receivedDateTemp[2]}-${receivedDateTemp[1]}-${receivedDateTemp[0]}`;
            }
          }
        } else {
          if (row.received_date) {
            row.received_date = moment(row?.received_date, "YYYY-MM-DD").format(
              "DD-MM-YYYY"
            );
          }
        }

        // formData.append(`contacts[${i}]`, JSON.stringify(row));

        Object.keys(row).forEach((key) => {
          if (
            key === "code" ||
            key === "first_name" ||
            key === "last_name" ||
            key === "phone" ||
            key === "mobile" ||
            key === "email" ||
            key === "business_name" ||
            key === "abn" ||
            key === "license_number" ||
            key === "street" ||
            key === "suburb" ||
            key === "state" ||
            key === "postal_code" ||
            key === "bank_name" ||
            key === "account_name" ||
            key === "bsb" ||
            key === "account_number"
          ) {
            formData.append(`receipts[${i}][${key}]`, row[key]);
          } else {
            if (key === "payment_method") {
              if (row.payment_method === "Select Tax") {
                formData.append(`receipts[${i}][${key}]`, "");
              } else {
                formData.append(
                  `receipts[${i}][${key}]`,
                  methodList?.find(
                    (item) => item?.label === row?.payment_method
                  )?.method_type
                );
              }
            } else {
              formData.append(`receipts[${i}][${key}]`, row[key]);
            }
          }
        });
      }

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      try {
        setIsImportLoading(true);
        const { data } = await fileUpload(
          `${API.IMPORT_RECEIPT}`,
          formData,
          config
        );
        setIsImportLoading(false);
        if (data) {
          setExcelSelectedRow([]);
          handleExcelClose();
          fetchData();
          handleImportClose();
          if (data?.data?.file) {
            const export_report_path = data?.data?.file;
            if (export_report_path) {
              var a = document.createElement("a");
              a.href = export_report_path;
              var file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-subcontractor.xls"
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
              setLoading(false);
            }
          }
        }
        return data?.data;
      } catch (error) {
        if (error?.response?.data?.errors) {
          if (error?.response?.data?.errors?.data?.file) {
            const export_report_path =
              error?.response?.data?.errors?.data?.file;
            if (export_report_path) {
              // eslint-disable-next-line no-redeclare
              var a = document.createElement("a");
              a.href = export_report_path;
              // eslint-disable-next-line no-redeclare
              var file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-sub-contractor.xls"
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
              setLoading(false);
            }
          }
          fetchData();
          setIsImportLoading(false);
        } else {
          setIsImportLoading(false);
        }
      }
      // }
    }
  };

  const handleExcelTableChange = async (
    type,
    { data, cellEdit: { rowId, dataField, newValue } }
  ) => {
    const getWithPromiseAll = async () => {
      let temp = await Promise.all(
        data.map(async (row) => {
          if (row?.key === rowId) {
            const newRow = { ...row };
            if (dataField === "account_number") {
              if (newValue) {
                newRow[dataField] = padWithLeadingZeros(Number(newValue), 9);
              } else {
                newRow[dataField] = "";
              }
            } else if (dataField === "mobile" || dataField === "phone") {
              newRow[dataField] = phoneFormat(newValue);
            } else if (dataField === "abn") {
              newRow[dataField] = newValue
                ? `${Number(newValue.split(" ").join(""))
                    .toLocaleString("en-US")
                    .replaceAll(",", " ")}`
                : "";
            } else if (dataField === "bsb") {
              if (String(newValue).match("-")) {
                newRow[dataField] =
                  padWithLeadingZeros(
                    Number(String(newValue).split("-").join("")),
                    6
                  ).slice(0, 3) +
                  "-" +
                  padWithLeadingZeros(
                    Number(String(newValue).split("-").join("")),
                    6
                  ).slice(3, 6);
              } else if (newValue) {
                newRow[dataField] =
                  padWithLeadingZeros(Number(newValue), 6).slice(0, 3) +
                  "-" +
                  padWithLeadingZeros(Number(newValue), 6).slice(3, 6);
              } else {
                newRow[dataField] = "";
              }
            } else {
              newRow[dataField] = newValue;
            }
            return newRow;
          }
          return row;
        })
      );
      return temp;
    };
    const result = await getWithPromiseAll();
    setExcelContactData(result);
  };
  return (
    <>
      {/* <AnimatedTooltip title={"Export Receipts"}>
        <Button
          onClick={() => handleDownload(0)}
          className="flex gap-2 items-center"
        >
          Export <Download size={18} />
        </Button>
      </AnimatedTooltip> */}
      <div className="flex bg-webPrimary rounded-md">
        <AnimatedTooltip title={"Import Receipts"}>
          <Button
            onClick={handleImportModal}
            className="bg-transparent flex items-center gap-1 px-2"
          >
            <FileSpreadsheet size={18} />
            {ButtonName}
          </Button>
        </AnimatedTooltip>
        <AnimatedTooltip title={"Download Template"}>
          <Button
            onClick={() => handleDownload(1)}
            className="bg-transparent border-l border-white dark:border-black  rounded-none px-2 rounded-se-md rounded-ee-md"
          >
            <Download size={18} />
          </Button>
        </AnimatedTooltip>
      </div>
      <ResponsiveDrawerForm
        description={""}
        title={"Import Receipts"}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        className={"sm:max-w-1/2"}
        open={showImport}
        buttonClassName={""}
        setOpen={setShowImport}
        mobileCancelHidden={true}
        write={true}
      >
        <>
          <FileUpload
            files={files}
            setFiles={setFiles}
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
          />

          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                handleExcelModal();
              }}
              disabled={files?.length === 0}
            >
              Upload
            </Button>
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                handleImportClose();
              }}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </>
      </ResponsiveDrawerForm>
      <ResponsiveDrawerForm
        description={""}
        title={"Upload Excel"}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"max:min-w-screen"}
        open={showExcelModal}
        buttonClassName={""}
        setOpen={setShowExcelModal}
        write={true}
      >
        <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
          {(isImportLoading || fileLoading) && (
            <Spin full expand={true} fullscreen={true} />
          )}

          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              selectRow={excelSelectRow}
              ref={excelRef}
              remote={{ cellEdit: true }}
              data={excelContactData ? excelContactData : []}
              columns={ExcelColumns}
              noDataIndication="No Data Found"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                timeToCloseMessage: 30000,
              })}
              onTableChange={handleExcelTableChange}
              rowClasses={TRClasses}
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
          <div className="pt-4 border-t mt-4 flex items-center justify-between">
            <div>Selected Records: {excelSelectedRow?.length}</div>
            <Button
              onClick={handleUpload}
              data-toggle="modal"
              data-target="#business"
              disabled={excelSelectedRow.length === 0 ? true : false}
            >
              Import
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>
    </>
  );
};

export default UploadReceipt;
